<template>
  <div class="form_root">
    <div class="text-left">
      <h3>
        <router-link to="/manuais">Manual</router-link> » {{crud_action}}
        <button v-if="!loading" @click.prevent="save()" class="btn btn-success pull-right">Salvar</button>
        <button v-else class="btn btn-muted pull-right">Aguarde...</button>
      </h3>
      <hr>
    </div>
    <!-- Manual -->
    <div class="row">
      <div class="form-group col-sm-12">
          <label for="ipt_cod" class="control-label">Titulo e Resumo</label>
          <input type="text" v-model="form.titulo" class="form-control" maxlength="" placeholder="Título e Resumo"/>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
            <label for="ipt_cod" class="control-label">Categoria</label>
            <select v-model="form.cat" class="form-control">
              <option value="Psweb">Psweb</option>
              <option value="Cupom Fiscal-CF">Cupom Fiscal</option>
              <option value="Cupom Eletrônico-NFCE">Cupom Eletrônico</option>
              <option value="Nota Eletrônica-NFE">Nota Eletrônica</option>
              <option value="Manifesto Eletrônico-MDFE">Manifesto Eletrônico</option>
              <option value="Postgres">Postgres</option>
            </select>
        </div>
        <div class="form-group">
            <label for="ipt_cod" class="control-label">SubCategoria</label>
            <select v-model="form.subcat" class="form-control">
              <option value="Autorização/Erros">Autorização/Erros</option>
              <option value="Problemas comuns">Problemas comuns</option>
              <option value="Sqls">SQLs</option>
              <option value="Configurações">Configuração</option>
              <option value="Legislação/Regulam.">Legislação/Regulam.</option>
              <option value="Instalação">Instalação</option>
              <option value="Impressoras">Impressoras</option>
            </select>
        </div>
        <div class="form-group">
            <label for="ipt_cod" class="control-label">Tags <small>(Palavras chave minusculas separadas por espaço)</small></label>
            <input type="text" v-model="form.tags" class="form-control" maxlength="" placeholder="Ex: psweb acbr"/>
        </div>
      </div>
      <div class="col-sm-9">
        <label class="control-label">Manual</label>
        <wysiwyg ref="manual"></wysiwyg>
      </div>
    </div>
  </div>
</template>

<script>
import wysiwyg from './Wysiwyg'
import swal from 'sweetalert'
export default {
  name: '',
  components: {
    wysiwyg
  },
  data () {
    return {
      loading: false,
      crud_action: '',
      form: {
        cod: 0,
        cat: '',
        subcat: '',
        titulo: '',
        manual: '',
        tags: '',
        dt_insert: '',
        excluido: 'f'
      }
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getmanual.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.fetchData(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    fetchData (o) {
      this.form = o
      this.$refs.manual.setContent(o.manual)
    },
    save () {
      this.form.manual = this.$refs.manual.getContent()
      const url = './api/php/addmanual.php'
      this.$http.post(url, JSON.stringify(this.form)).then(
        function (response) {
          console.log(response.body)
          if (response.body.status) {
            swal('Manual Cadastrado', '', 'success')
          }
          this.closeForm()
        },
        function (error) {
          console.log(error)
        }
      )
    },
    closeForm () {
      this.$router.push({path: '/manuais'})
    }
  },
  created: function () {
    const crud = this.$route.params.crud
    const cod = this.$route.params.id
    if (crud === 'c') {
      // Cria novo Manual
      console.log('Criando novo manual')
      this.crud_action = 'Novo'
    } else if (crud === 'u') {
      // Altera um Manual
      console.log('Alterando um email')
      this.crud_action = 'Alterando (#' + cod + ')'
      this.load({'cod': cod})
    } else {
      console.log('CRUD INVÁLIDO EM FORM MANUAL')
    }
  }
}
</script>

<style scoped>
  .loading {
    background: url("../assets/loading.gif") center no-repeat;
    background-size: cover;
    display: block;
    width: 30vw;
    height: 30vh;
    margin: 25vh 35vw;
  }
  .form_root {
      text-align: left;
      margin: auto;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
    .calendario {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 100;
    }
</style>



// WEBPACK FOOTER //
// src/components/ManForm.vue